import * as React from 'react';
import ReactTable from 'react-table';
import { CoverageOption } from '@models/CoverageOption';
import { Column } from 'react-table';
import { OptionsViewModel } from '@models/common.models';
import { ProductViewModel } from '@models/Product';

export interface ViewSelectedCoveragesComponentProperties {
  readonly coverageOptions: Array<CoverageOption>;
  readonly hasSellersCoverage: boolean;
  readonly product?: OptionsViewModel; // TODO productViewModel?
}

export class ViewSelectedCoveragesComponent extends React.Component<ViewSelectedCoveragesComponentProperties> {
  constructor(props: ViewSelectedCoveragesComponentProperties) {
    super(props);
  }

  getColumns() {
    const productDesc = this.props.product && (this.props.product as ProductViewModel).productDesc;
    let columns: Array<Column> = [
      {
        accessor: 'value',
        Header: productDesc ? `Selected Coverage - ${productDesc}` : 'Selected Coverage',
        sortable: false
      },
      {
        accessor: 'price',
        width: 100,
        Cell: (props: { value: number }) => <label>{props.value ? '$' + props.value.toFixed(2) : 'N/A'}</label>,
        Header: this.props.hasSellersCoverage ? 'Buyer Price' : 'Price',
        sortable: false
      }
    ];

    if (this.props.hasSellersCoverage) {
      columns = columns.concat({
        accessor: 'sellersPrice',
        Header: 'Seller Price',
        width: 100,
        Cell: (props: { value: number }) => <label>{props.value ? '$' + props.value.toFixed(2) : 'N/A'}</label>,
        sortable: false
      });
    }

    return columns;
  }

  getPriceData() {
    /*const productId: number = this.props.selectedProduct ? this.props.selectedProduct.id : 0;
        const foundProduct = (this.props.products.find((product) => +product.id === +productId));

        return foundProduct ? [foundProduct].concat(this.props.coverageOptions) : [];*/
    if (!this.props.product || this.props.product.id === -1) {
      return [];
    }
    return this.props.coverageOptions;
  }

  render() {
    return (
      <ReactTable
        onPageChange={() => {
          Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
            element.scrollTop = 0;
          });
        }}
        key={this.props.coverageOptions.length}
        className="-striped -highlight"
        defaultPageSize={this.props.coverageOptions.length || 25}
        columns={this.getColumns()}
        data={this.getPriceData()}
        showPagination={false}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/_components/view-selected-coverages.componet.tsx